import { c as _c } from "react/compiler-runtime";
import { IcoBuilding16 } from '@onefootprint/icons';
import type { HostedBusiness } from '@onefootprint/request-types';
import { Badge, Button, Divider, PageShell } from '@onefootprint/ui';
import { differenceInDays, differenceInHours, format, formatDistance } from 'date-fns';
import { useTranslation } from 'react-i18next';
export type CreateBusinessOnboardingProps = {
  businesses: HostedBusiness[];
  onSelect: (id: string) => void;
  onAddNew: () => void;
  isBusy: boolean;
};
export const CreateBusinessOnboarding = t0 => {
  const $ = _c(42);
  const {
    businesses,
    onSelect,
    onAddNew,
    isBusy
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "createBusinessOnboarding.businessSelector"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] !== businesses.length || $[2] !== t) {
    t2 = t(_temp, {
      count: businesses.length
    });
    $[1] = businesses.length;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const title = t2;
  let t3;
  if ($[4] !== t) {
    t3 = date => {
      const now = new Date();
      const activityDate = new Date(date);
      const hoursAgo = differenceInHours(now, activityDate);
      const daysAgo = differenceInDays(now, activityDate);
      if (hoursAgo < 24) {
        return t(_temp2, {
          time: formatDistance(activityDate, now)
        });
      }
      if (daysAgo < 30) {
        return t(_temp3, {
          days: daysAgo,
          count: daysAgo
        });
      }
      return t(_temp4, {
        date: format(activityDate, "MM/dd/yyyy")
      });
    };
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const formatRelative = t3;
  let t4;
  if ($[6] !== t) {
    t4 = t(_temp5);
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      headerTitleCentered: true
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== businesses || $[10] !== formatRelative || $[11] !== onSelect || $[12] !== t) {
    let t7;
    if ($[14] !== formatRelative || $[15] !== onSelect || $[16] !== t) {
      t7 = business => <button key={business.id} type="button" onClick={() => onSelect(business.id)} className="bg-primary border border-tertiary p-5 pb-3 w-full block rounded-md cursor-pointer hover:border-primary text-left"><div className="flex items-center justify-between mb-3 h-5"><span className="text-caption-1 text-tertiary">{formatRelative(business.lastActivityAt)}</span>{business.isIncomplete ? <Badge variant="warning">{t(_temp6)}</Badge> : null}</div><div className="flex gap-3 items-center mb-5"><IcoBuilding16 color="primary" /><span className="text-label-2 text-primary">{business.name}</span></div><Divider /><div className="mt-3"><span className="text-caption-1 text-tertiary">{t(_temp7, {
              date: format(new Date(business.createdAt), "MM/dd/yyyy")
            })}</span></div></button>;
      $[14] = formatRelative;
      $[15] = onSelect;
      $[16] = t;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    t6 = businesses.map(t7);
    $[9] = businesses;
    $[10] = formatRelative;
    $[11] = onSelect;
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[18] !== t6) {
    t7 = <div className="flex flex-col gap-4 w-full">{t6}</div>;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Divider />;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t) {
    t9 = t(_temp8);
    $[21] = t;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t9) {
    t10 = <span className="text-body-2 text-tertiary">{t9}</span>;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Divider />;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10) {
    t12 = <div className="flex gap-4 w-full items-center">{t8}{t10}{t11}</div>;
    $[26] = t10;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t) {
    t13 = t(_temp9);
    $[28] = t;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== isBusy || $[31] !== onAddNew || $[32] !== t13) {
    t14 = <Button onClick={onAddNew} fullWidth={true} size="large" loading={isBusy}>{t13}</Button>;
    $[30] = isBusy;
    $[31] = onAddNew;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t12 || $[35] !== t14 || $[36] !== t7) {
    t15 = <div className="flex flex-col gap-5 w-full">{t7}{t12}{t14}</div>;
    $[34] = t12;
    $[35] = t14;
    $[36] = t7;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t15 || $[39] !== t4 || $[40] !== title) {
    t16 = <PageShell title={title} subtitle={t4} options={t5}>{t15}</PageShell>;
    $[38] = t15;
    $[39] = t4;
    $[40] = title;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  return t16;
};
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.lastActivity.hours;
}
function _temp3($_1) {
  return $_1.lastActivity.days;
}
function _temp4($_2) {
  return $_2.lastActivity.date;
}
function _temp5($_3) {
  return $_3.subtitle;
}
function _temp6($_4) {
  return $_4.status.incomplete;
}
function _temp7($_5) {
  return $_5.createdAt;
}
function _temp8($_6) {
  return $_6.or;
}
function _temp9($_7) {
  return $_7.cta;
}